<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Filter Toolbar
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">
  <div class="content--modifier-height">
    <h2>Customized Sort and Filter</h2>
    <div class="content__tools-wrap">
      <div class="content__row">
        <div class="c-input-check-inline">
          <input id="hasSearchOption" class="c-input-check-inline__input" type="checkbox" name="hasSearchOption"
            [(ngModel)]="hasSearchOption">
          <label for="hasSearchOption" class="c-input-check-inline__label">Has Search Option</label>
        </div>
        <div class="c-input-check-inline">
          <input id="hasSorting" class="c-input-check-inline__input" type="checkbox" name="hasSorting"
            [(ngModel)]="hasSorting">
          <label for="hasSorting" class="c-input-check-inline__label">Has Sorting</label>
        </div>
        <div class="c-input-check-inline">
          <input id="hasFilter" class="c-input-check-inline__input" type="checkbox" name="hasFilter"
            [(ngModel)]="hasFilter">
          <label for="hasFilter" class="c-input-check-inline__label">Has Filter</label>
        </div>
        <div class="c-input-check-inline" *ngIf="hasSorting">
          <input id="hasVeiwBy" class="c-input-check-inline__input" type="checkbox" name="hasVeiwBy"
            [(ngModel)]="hasVeiwBy">
          <label for="hasVeiwBy" class="c-input-check-inline__label">Has View By</label>
        </div>
        <div class="c-input-check-inline" *ngIf="hasSorting">
          <input id="hasSortBy" class="c-input-check-inline__input" type="checkbox" name="hasSortBy"
            [(ngModel)]="hasSortBy">
          <label for="hasSortBy" class="c-input-check-inline__label">Has Sort By</label>
        </div>
      </div>
    </div>
  </div>
  <maced-filter-toolbar filterToolbarId="filterToolbarId" [hasSearchOption]="hasSearchOption" [hasSorting]="hasSorting">
    <ng-container ngProjectAs="[searchPannel]">
      <form [formGroup]="formElement">
        <maced-search placeholder="Search" id="input" name="input" [hasIcon]="true" autocomplete="on" type="text"
          value="" errorMessage=" " [label]="searchInputLabelEnglish" formControlName="inputVal"
          [hasExternalButton]="hasExternalButton" buttonUrl="/filter-sorting">
        </maced-search>
      </form>
    </ng-container>
    <ng-container ngProjectAs="[dropdownPannel]">
      <div class="c-filter-toolbar__sort-filter-group-sortby" *ngIf="!isBrowser">
        <ul class="c-filter-toolbar__sort-filter-group-list">
          <li
          class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown">
          <maced-dropdown dropdownId="dropdownId5" name="dropdownId5" ariaLabel="Dropdown list navigate with tab"
            label="Oldest first" cheveronClass="icon-chevron-down" [options]="options1" [hasBackgroundActive]="true"
            [selectedOption]="selectedOptions1" outerLabel="Sort By:" dropdownLabelId="dropdownLabelId0">
          </maced-dropdown>
        </li>
        <li
          class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown">
          <maced-dropdown dropdownId="dropdownId2" name="dropdownId2" ariaLabel="Dropdown list navigate with tab" [hasBackgroundActive]="true"
            label="All time" cheveronClass="icon-chevron-down" [options]="options2" [selectedOption]="selectedOptions2"
            outerLabel="View By:" dropdownLabelId="dropdownLabelId1">
          </maced-dropdown>
        </li>
        </ul>
      </div>
      <div class="c-filter-toolbar__sort-filter-group-filter">
        <ul class="c-filter-toolbar__sort-filter-group-list">
          <li
            class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown"
            *ngIf="hasVeiwBy && screenSize > minimumScreenResolution && isBrowser">
            <maced-dropdown dropdownId="dropdownId5" name="dropdownId5" ariaLabel="Dropdown list navigate with tab"
              label="Oldest first" cheveronClass="icon-chevron-down" [options]="options1" [hasBackgroundActive]="true"
              [selectedOption]="selectedOptions1" outerLabel="Sort By:" dropdownLabelId="dropdownLabelId0">
            </maced-dropdown>
          </li>
          <li
            class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown"
            *ngIf="hasSortBy && screenSize > minimumScreenResolution  && isBrowser">
            <maced-dropdown dropdownId="dropdownId2" name="dropdownId2" ariaLabel="Dropdown list navigate with tab"
              label="All time" cheveronClass="icon-chevron-down" [options]="options2" [selectedOption]="selectedOptions2"
              outerLabel="View By:" dropdownLabelId="dropdownLabelId1" [hasBackgroundActive]="true">
            </maced-dropdown>
          </li>
          <li class="c-filter-toolbar__sort-filter-group-list-item" *ngIf="hasFilter && isBrowser">
            <maced-floating-panel *ngIf="screenSize>minimumScreenResolution" id="floatingpanel1" [hasEscapFunctionality]="false"
              [placement]="selectedPlacement" [hasCloseButton]="hasCloseButton" [hasBackdrop]="hasBackdrop"
              [hasCaret]="hasCaret" [hasFooter]="true" [buttonList]="buttonList" (applySelectedOptions)="buttonFocus()">
              <ng-container ngProjectAs="[floatingPanelTarget]">
                <div class="c-filter-button">
                  <maced-button buttonId="buttonId1" size="large" type="button" icon="icon-filter-funnel"
                    [label]="buttonLabelText()" position="left" [ariaLabel]="buttonLabelText()" [ngClass]="{'u-button--badge':( selectedList && selectedList.length>0)}" [ariaExpanded]="ariaExpanded">
                    <ng-container ngProjectAs="[childComponent]">
                      <maced-badge *ngIf="selectedList.length>0" badgeId="badgeId3" label="badge1" ariaLabel="Ninty"
                        size="dot"></maced-badge>
                    </ng-container>
                  </maced-button>
                </div>
              </ng-container>
              <ng-container ngProjectAs="[floatingPanelBody]">
                <div class="c-floating-panel__body c-floating-panel__body--medium">
                  <div class="c-floating-panel__body-block">
                    <ul class="c-floating-panel__body-block-list">
                      <li class="c-floating-panel__body-block-list-item">
                        <maced-dropdown dropdownId="dropdownId10" name="dropdownId10" ariaLabel="Dropdown"
                          label="Please select" cheveronClass="icon-chevron-down" [options]="options10"
                          [selectedOption]="selectedOptions10" outerLabel="Category" dropdownLabelId="dropdownLabelId10">
                        </maced-dropdown>
                      </li>
                      <li class="c-floating-panel__body-block-list-item">
                        <maced-dropdown dropdownId="dropdownId11" name="dropdownId11" ariaLabel="Dropdown"
                          label="Please select" cheveronClass="icon-chevron-down" [options]="options11"
                          [selectedOption]="selectedOptions11" outerLabel="Label" dropdownLabelId="dropdownLabelId11">
                        </maced-dropdown>
                      </li>
                      <li class="c-floating-panel__body-block-list-item">
                        <form action="/multi-select" method="get" id="form2">
                          <maced-multi-select multiSelectId="multiSelectId" ariaLabel="multi select search" placeholder="placeholder" formId="form2" [hasTruncation]="true" (inputValue)="inputValue($event)"
                            label="Select" multiSelectLabelId="multiSelectLabelId" [selectedOptionList]="selectedOptionList" [options]="options" (optionEvent)="onClickOption($event)">
                          </maced-multi-select>
                        </form>
                      </li>
                    </ul>  
                  </div>
                </div>
              </ng-container>
              <ng-container ngProjectAs="[floatingPanelFooter]">
                <div aria-live="polite" class="c-display-none">{{clearData}}</div>
              </ng-container>
            </maced-floating-panel>  
            <maced-floating-panel *ngIf="screenSize<=minimumScreenResolution" id="floatingpanel2" [hasEscapFunctionality]="false"
              [placement]="selectedPlacement" [hasCloseButton]="hasCloseButton" [hasBackdrop]="hasBackdrop"
              [hasCaret]="hasCaret" [hasFooter]="true" [buttonList]="buttonList" [hasCloseButton]="true">
              <ng-container ngProjectAs="[floatingPanelTarget]">
                <div class="c-filter-button">
                  <maced-button buttonId="buttonId1" size="large" type="button" icon="icon-filter-funnel"
                    [label]="buttonLabelText()" position="left" [ariaLabel]="buttonLabelText()" [ngClass]="{'u-button--badge':( selectedList && selectedList.length>0)}">
                    <ng-container ngProjectAs="[childComponent]">
                      <maced-badge *ngIf="selectedList.length>0" badgeId="badgeId3" label="badge1" ariaLabel="Ninty"
                        size="dot"></maced-badge>
                    </ng-container>
                  </maced-button>
                </div>
              </ng-container>
              <ng-container ngProjectAs="[floatingPanelBody]">
                <div class="c-floating-panel__body c-floating-panel__body--medium">
                  <div class="c-floating-panel__body-header">Filters</div>
                  <div class="c-floating-panel__body-block">
                    <ul class="c-floating-panel__body-block-list">
                      <li class="c-floating-panel__body-block-list-item">
                        <maced-radio-group radioGroupId="radioGroupId1" label="Sort By" [required]="true">
                          <div class="c-input-outer__multiple-item" *ngFor="let item of sortByList let inx = index">
                            <maced-radio [radioId]="'sortByRadio' + inx" [value]="item.label" [required]="true"
                              [checked]="item.label === item.checked" name="sortByRadio" [label]="item.label"
                              (change)="singleCheckbox(item,'sortBy',$event)">
                            </maced-radio>
                          </div>
                        </maced-radio-group>
                      </li>
                      <li class="c-floating-panel__body-block-list-item">
                        <maced-radio-group radioGroupId="radioGroupId2" label="View By" [required]="true">
                          <div class="c-input-outer__multiple-item" *ngFor="let item of viewByList let inx = index">
                            <maced-radio [radioId]="'viewByRadio' + inx" [value]="item.label" [required]="true"
                              [checked]="item.label === item.checked" name="viewByRadio" [label]="item.label"
                              (change)="singleCheckbox(item,'viewBy',$event)">
                            </maced-radio>
                          </div>
                        </maced-radio-group>
                      </li>
                      <li
                        class="c-floating-panel__body-block-list-item c-floating-panel__body-block-list-item--is-active"
                        *ngIf="hasVeiwBy">
                        <maced-dropdown dropdownId="dropdownId12" name="dropdownId12"
                          ariaLabel="Dropdown list navigate with tab" label="Please select"
                          cheveronClass="icon-chevron-down" [options]="options10" [selectedOption]="selectedOptions10"
                          outerLabel="Category" dropdownLabelId="dropdownLabelId12">
                        </maced-dropdown>
                      </li>
                      <li class="c-floating-panel__body-block-list-item" *ngIf="hasSortBy">
                        <maced-dropdown dropdownId="dropdownId13" name="dropdownId13"
                          ariaLabel="Dropdown list navigate with tab" label="Please select"
                          cheveronClass="icon-chevron-down" [options]="options11" [selectedOption]="selectedOptions11"
                          outerLabel="Label" dropdownLabelId="dropdownLabelId13">
                        </maced-dropdown>
                      </li>
                      <li class="c-floating-panel__body-block-list-item" *ngIf="hasSortBy">
                        <form action="/multi-select" method="get" id="form2">
                          <maced-multi-select multiSelectId="multiSelectId" ariaLabel="multi select search" placeholder="placeholder" formId="form2" [hasTruncation]="true"
                            label="Select" multiSelectLabelId="multiSelectLabelId" [selectedOptionList]="selectedOptionList" [options]="options" (optionEvent)="onClickOption($event)">
                          </maced-multi-select>
                        </form>
                      </li>
                    </ul>  
                  </div>
                </div>
              </ng-container>
            </maced-floating-panel>
          </li>
          <li  class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown" *ngIf="!isBrowser">
            <maced-dropdown dropdownId="dropdownId10" name="dropdownId10" ariaLabel="Dropdown"
              label="Please select" cheveronClass="icon-chevron-down" [options]="options10"
              [selectedOption]="selectedOptions10" outerLabel="Category" dropdownLabelId="dropdownLabelId10">
            </maced-dropdown>
          </li>
          <li  class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown" *ngIf="!isBrowser">
            <maced-dropdown dropdownId="dropdownId11" name="dropdownId11" ariaLabel="Dropdown"
              label="Please select" cheveronClass="icon-chevron-down" [options]="options11"
              [selectedOption]="selectedOptions11" outerLabel="Label" dropdownLabelId="dropdownLabelId11">
            </maced-dropdown>
          </li>
          <li  class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown" *ngIf="!isBrowser">
            <form action="/filter-sorting" method="get" id="form2">
              <maced-multi-select multiSelectId="multiSelectId" ariaLabel="multi select search" placeholder="placeholder" formId="form2" [hasTruncation]="true"
                label="Select" multiSelectLabelId="multiSelectLabelId" [selectedOptionList]="selectedOptionList" [options]="options" (optionEvent)="onClickOption($event)">
              </maced-multi-select>
              <div class="c-multi-select__height--modifier">
                <maced-button buttonId="submit" label="Submit" buttonType="submit"></maced-button>
              </div>
            </form>          
          </li>
          <li  class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown" *ngIf="!isBrowser">
            <ng-container *ngFor="let buttonList of buttonList">    
              <maced-button *ngIf="buttonList.hasClearButton" [buttonId]="buttonList.id" color="link" 
                [type]="isBrowser ? 'button': 'link'" [url]="currentUrl" [label]="buttonList.label"
                [ariaLabel]="buttonList.label" [queryParams]="buttonList.queryParams"
                [queryParamsHandling]="buttonList?.url === currentUrl?'merge':''"
                [routerLink]="buttonList.disabled ? null : buttonList?.url" [disabled]="buttonList.disabled">
              </maced-button>    
              <maced-button *ngIf="buttonList.hasApplyButton" [buttonId]="buttonList.id" color="primary" 
                [type]="isBrowser ? 'button': 'link'" [url]="currentUrl" [label]="buttonList.label"
                [ariaLabel]="buttonList.label" [queryParams]="buttonList.queryParams"
                [queryParamsHandling]="buttonList?.url === currentUrl?'merge':''"
                [routerLink]="buttonList.disabled ? null : buttonList?.url" [disabled]="buttonList.disabled">
              </maced-button>
            </ng-container>
          </li>
        </ul>
      </div>
    </ng-container>
  </maced-filter-toolbar>
  <ng-container *ngIf="hasErrorState">
    <maced-error-state [id]="id3" [imageUrl]="imageUrl3" [title]="title3" [ariaLabels]="ariaLabels" [imageWidthLarge]=202 [imageHeightLarge]=179>
      <ng-container ngProjectAs="[content-body]">
        Enter another keyword to search
      </ng-container>
    </maced-error-state>
  </ng-container>
</div>